// extracted by mini-css-extract-plugin
export default {"locations":"_65b6daa2","content":"_f74108c5"};